import React from 'react';
import { Select } from 'antd';

const { Option } = Select;

const GROUPS = ['N1', 'N2'];

export const SelectGroup = ({ value, onChange }) => (
  <label>
    {'Fait partie du groupe : '}
    <Select
      defaultValue={value || ''}
      style={{ minWidth: 50 }}
      onChange={onChange}
    >
      {!value &&
        <Option value="">&nbsp;</Option>
      }
      {GROUPS.map(g => (
        <Option key={g} value={g}>{g} </Option>
      ))}
    </Select>
  </label>
);

export default SelectGroup;



// WEBPACK FOOTER //
// ./src/components/Admin/UsersManagement/UserEdit/Form/SelectGroup.js